// source: witbooking/backoffice/adminkeycloak/v1/adminkeycloak.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser', null, global);
goog.exportSymbol('proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest.displayName = 'proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse.displayName = 'proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.displayName = 'proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.displayName = 'proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest}
 */
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest;
  return proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest}
 */
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    usersList: jspb.Message.toObjectList(msg.getUsersList(),
    proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse}
 */
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse;
  return proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse}
 */
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser;
      reader.readMessage(value,proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.serializeBinaryToWriter
    );
  }
};


/**
 * repeated KeycloakUser users = 1;
 * @return {!Array<!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser>}
 */
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser>} value
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse} returns this
*/
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser}
 */
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse} returns this
 */
proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    groupsList: jspb.Message.toObjectList(msg.getGroupsList(),
    proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser}
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser;
  return proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser}
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup;
      reader.readMessage(value,proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.deserializeBinaryFromReader);
      msg.addGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser} returns this
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser} returns this
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated KeycloakUserGroup groups = 3;
 * @return {!Array<!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup>}
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.prototype.getGroupsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup, 3));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup>} value
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser} returns this
*/
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.prototype.setGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup}
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.prototype.addGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser} returns this
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUser.prototype.clearGroupsList = function() {
  return this.setGroupsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    path: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup}
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup;
  return proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup}
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup} returns this
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup} returns this
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string path = 3;
 * @return {string}
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup} returns this
 */
proto.witbooking.backoffice.adminkeycloak.v1.KeycloakUserGroup.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


goog.object.extend(exports, proto.witbooking.backoffice.adminkeycloak.v1);
